<div class="trax-navbar-wrapper" [class.top]="isAtTop">
  <div class="trax-navbar-area" [class.top]="isAtTop">
    <div class="trax-navbar-container container external-user h-100 d-md-flex align-items-center justify-content-evenly">
      <div class="header h-100 d-flex align-items-center">
        <div class="hamburger" [class.open]="isMenuOpened" (click)="isMenuOpened = !isMenuOpened">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="logo" [class.top]="isAtTop">
          <img [src]="isAtTop && isLargeScreenWidth ? '../../../../assets/images/header/TRAXhorizontal.png' : '../../../../assets/images/header/TRAXhorizontalWhite.png'" />
        </div>
      </div>
      <div class="menu navbar" [class.open]="isMenuOpened" [class.top]="isAtTop">
        <ul #priorityNav class="nav navbar-nav priority-nav">
          <li *ngFor="let menuItem of menuItems; trackBy: trackByFn" class="nav-item priority-nav-item">
            <div *ngIf="!menuItem.children || menuItem.children.length === 0" class="nav-display">
              <a *ngIf="menuItem.route" [routerLink]="menuItem.route">{{ menuItem.displayName }}</a>
              <a *ngIf="menuItem.url" (click)="navigateTo(menuItem.url)">{{ menuItem.displayName }}</a>
            </div>
            <div *ngIf="menuItem.children && menuItem.children.length > 0" ngbDropdown #subMenuDropdown="ngbDropdown" (mouseover)="subMenuDropdown.open()" (mouseleave)="subMenuDropdown.close()">
              <div class="nav-display" ngbDropdownAnchor>{{ menuItem.displayName }}</div>
              <div class="dropdown-menu position-absolute" ngbDropdownMenu>
                <ng-container *ngFor="let childItem of menuItem.children; trackBy: trackByFn">
                  <a *ngIf="childItem.route" class="dropdown-item nav-display" [routerLink]="childItem.route">{{ childItem.displayName }}</a>
                  <a *ngIf="childItem.url" class="dropdown-item nav-display" (click)="navigateTo(childItem.url)">{{ childItem.displayName }}</a>
                </ng-container>
              </div>
            </div>
          </li>
          <li #priorityNavMore class="nav-item priority-nav-more" [class.invisible]="moreMenuItems.length === 0"  [style.order]="moreOrder" ngbDropdown #moreMenu="ngbDropdown" (mouseover)="moreMenu.open()" (mouseleave)="moreMenu.close()">
            <div class="nav-display" ngbDropdownAnchor>More</div>
            <div class="dropdown-menu position-absolute" ngbDropdownMenu>
              <div *ngFor="let moreMenuItem of moreMenuItems; trackBy: trackByFn" [style.order]="menuItems.indexOf(moreMenuItem)">
                <div *ngIf="!moreMenuItem.children || moreMenuItem.children.length === 0">
                  <a *ngIf="moreMenuItem.route" class="dropdown-item nav-display" [routerLink]="moreMenuItem.route">{{ moreMenuItem.displayName }}</a>
                  <a *ngIf="moreMenuItem.url" class="dropdown-item nav-display" (click)="navigateTo(moreMenuItem.url)">{{ moreMenuItem.displayName }}</a>
                </div>
                <div *ngIf="moreMenuItem.children && moreMenuItem.children.length > 0" display="dynamic" ngbDropdown #moreMenuDropdown="ngbDropdown" placement="right-top" (mouseover)="moreMenuDropdown.open()" (mouseleave)="moreMenuDropdown.close()">
                  <div class="more-menu-display dropdown-item" ngbDropdownAnchor>{{ moreMenuItem.displayName }}</div>
                    <div class="dropdown-menu position-absolute more-menu-dropdown" ngbDropdownMenu>
                      <ng-container *ngFor="let childItem of moreMenuItem.children; trackBy: trackByFn" >
                        <a *ngIf="childItem.route" class="dropdown-item nav-display" [routerLink]="childItem.route">{{ childItem.displayName }}</a>
                        <a *ngIf="childItem.url" class="dropdown-item nav-display" (click)="navigateTo(childItem.url)">{{ childItem.displayName }}</a>
                      </ng-container>
                    </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="nav icons" [class.top]="isAtTop">
          <div class="icon user" ngbDropdown #userDropdown="ngbDropdown" display="dynamic" placement="bottom" (mouseover)="userDropdown.open()" (mouseleave)="userDropdown.close()">
            <img ngbDropdownAnchor [src]="isAtTop && isLargeScreenWidth ? '../../../../assets/images/header/user_black.png' : '../../../../assets/images/header/user_white.png'" />
            <div class="dropdown-menu" ngbDropdownMenu>
              <div class="dropdown-item-text">{{companyName}}</div>
              <a *ngIf="shouldDisplayCustomerSelect()" class="dropdown-item" (click)="openCustomerSelect()" [routerLink]="" routerLinkActive="router-link-active" >SWITCH PROFILE</a>
              <a class="dropdown-item" routerLink='/logout'>LOGOUT</a>
            </div>
          </div>
          <div class="icon settings">
            <a (click)="navigateTo(traxAdminUrl)">
              <img [src]="isAtTop && isLargeScreenWidth ? '../../../../assets/images/header/settings_black.png' : '../../../../assets/images/header/settings_white.png'" />
            </a>
          </div>
          <div class="icon faq">
            <a (click)="navigateTo(traxFAQUrl)">
              <img [src]="isAtTop && isLargeScreenWidth ? '../../../../assets/images/header/help_black.png' : '../../../../assets/images/header/help_white.png'" />
            </a>
          </div>
        </ul>
      </div>
    </div>
  </div>
</div>